<template>

    <span class='completed_mark' :class="{'is-completed': evaluation.completed}"></span>

</template>

<script>
export default {
    name: 'completedMark',
    props: {
        evaluation: {
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.completed_mark{
    height: 12px;
    width: 12px;
    background-color: #ffdd57;
    display: block;
    border-radius: 100%;
    background-color: $pending-color;
    &.is-completed{
        background-color: $completed-color;
    }
}
</style>